function createFeaturedCollectionItemRenderer(saleColor, badgeOnImage) {
      function productCatalog(hit){
        if (hit.meta.product.wholesale_prices){
          const catalogs = JSON.parse(hit.meta.product.wholesale_prices);
          const foundCatalog = catalogs.find(priceInfo => priceInfo.catalog === algoliaShopify.catalog);

          if (foundCatalog) {
            return foundCatalog;
          } else {
            return null;
          }
        }
        else {
          return null;
        }
      };
      function formatPrice(value) {
        return algoliaShopify.formatMoney(Number(value) * 100);
      };
      function formatPercentage(decimal) {
        // Ensure the input is a number
        if (typeof decimal !== 'number') {
            throw new Error('Input must be a number');
        }

        // Multiply by 100 to convert to percentage
        let percentage = decimal * 100;

        // Format the number to two decimal places
        percentage = percentage.toFixed(2);

        // Append the percentage symbol and return the result
        return percentage + '%';
      };
      function reviewData(item) {
        if (!item.meta || !item.meta.reviews || !item.meta.reviews.rating) {
          return null;
        }

        try {
          var ratingParsed = typeof item.meta.reviews.rating === 'string'
            ? JSON.parse(item.meta.reviews.rating)
            : item.meta.reviews.rating;
          var rating = Number(ratingParsed.value);
          var scaleMax = Number(ratingParsed.scale_max);
          var count = Number(item.meta.reviews.rating_count);

          if (!Number.isFinite(rating) || !Number.isFinite(scaleMax) || !Number.isFinite(count) || rating <= 0 || scaleMax <= 0 || count <= 0) {
            return null;
          }

          return {
            rating: rating,
            scaleMax: scaleMax,
            count: count,
            percentage: Math.min(100, Math.max(0, (rating / scaleMax) * 100))
          };
        } catch (error) {
          return null;
        }
      };
      function reviewRatingMarkup(review) {
        if (!review) {
          return '<div class="mtbd-review-rating mtbd-review-rating--empty" aria-hidden="true"></div>';
        }

        return `<div class="mtbd-review-rating" role="img" aria-label="${review.rating} out of ${review.scaleMax} stars from ${review.count} reviews">
          <span class="mtbd-review-rating__stars" aria-hidden="true">
            <span class="mtbd-review-rating__stars-fill" style="width: ${review.percentage}%;"></span>
          </span>
          <span class="mtbd-review-rating__count" aria-hidden="true">(${review.count})</span>
        </div>`;
      };
      function priceData(hit) {
        const catalog = productCatalog(hit);
        var priceData = {};
        if (catalog) {
          priceData = {
            catalog_price: true,
            price:  catalog.price ? catalog.price : null,
            display_price_formatted: '',
            compare_at_price: hit.meta.product.b2b_margin_base_price ? hit.meta.product.b2b_margin_base_price : null,
            display_compare_at_price_formatted: '',
            margin: 0.00,
            margin_formatted: '',
            minimum_price: catalog.min_price ? catalog.min_price : null,
            maximum_price: catalog.max_price ? catalog.max_price : null,
            clearance: catalog.clearance ? catalog.clearance : false
          };
        }
        else{
          priceData = {
            catalog_price: false,
            price: hit.price,
            display_price_formatted: '',
            compare_at_price: hit.compare_at_price,
            display_compare_at_price_formatted: '',
            margin: 0.00,
            margin_formatted: '',
            minimum_price: hit.meta.product.minimum_price,
            maximum_price: hit.meta.product.maximum_price,
            clearance: false
          };
        }

        priceData.display_compare_at_price = (priceData.minimum_price != priceData.maximum_price
          ? false
          : (priceData.compare_at_price > priceData.maximum_price
              ? (priceData.compare_at_price - priceData.maximum_price) < 0.06
                ? false
                : true
              : false));
        if (priceData.display_compare_at_price) {
          priceData.margin = (priceData.compare_at_price - priceData.price)/priceData.compare_at_price;
          priceData.margin_formatted = formatPercentage(priceData.margin);
        }
        priceData.display_compare_at_price_formatted = formatPrice(priceData.compare_at_price);

        if (priceData.minimum_price != priceData.maximum_price) {
          priceData.display_price_formatted = formatPrice(priceData.minimum_price) + ' - ' + formatPrice(priceData.maximum_price);
        }
        else {
          priceData.display_price_formatted = formatPrice(priceData.price);
        }

        return priceData;
      };
      function displayCustomSalesBadge(saleBadgeText, saleStartDate, saleEndDate){
        if (typeof saleBadgeText !== 'string' || saleBadgeText.trim() === '') return false;
        var todayDate = new Date();
        if (saleStartDate){
          saleStartDate = new Date(saleStartDate);
        } else {
          return false
        }
        if (saleEndDate){
          saleEndDate = new Date(saleEndDate);
        } else {
          return false
        }

        return ( todayDate >= saleStartDate && todayDate <= saleEndDate && saleBadgeText )
      }
      function plpTitle(hit) {
        var res = hit.title;
        if (hit.meta && hit.meta.product && hit.meta.product.plp_title) {
          res = hit.meta.product.plp_title;
        } else if (
          !hit._distinct &&
          hit.variant_title &&
          hit.variant_title !== 'Default Title' &&
          hit.variant_title !== 'Default'
        ) {
          res += ' (' + hit.variant_title + ')';
        }

        return res;
      };
      function plpTitleModel(hit) {
        var res = hit.title;
        if (hit.meta && hit.meta.product && hit.meta.product.plp_title) {

          //Remove the colour section from the PLP title
          const parts = hit.meta.product.plp_title.split(' - '); // Split the text into an array using ' - ' as the separator
          res = parts[0]; // Get the first part of the array

          //Remove Vendor from the plp title
          const regex = new RegExp(hit.vendor, "i");
          res = res.replace(regex, "");

        } else if (
          !hit._distinct &&
          hit.variant_title &&
          hit.variant_title !== 'Default Title' &&
          hit.variant_title !== 'Default'
        ) {
          res += ' (' + hit.variant_title + ')';
        }
        res = res.trim();
        return res.trim();
      };
      function plpTitleColour(hit) {
        var res = hit.title;
        if (hit.meta && hit.meta.product && hit.meta.product.plp_title) {

          //Return the colour section from the PLP title
          const parts = hit.meta.product.plp_title.split(' - '); // Split the text into an array using ' - ' as the separator
          res = parts.slice(1).join(' - '); //parts[1]; // Get the first part of the array
        } else if (
          !hit._distinct &&
          hit.variant_title &&
          hit.variant_title !== 'Default Title' &&
          hit.variant_title !== 'Default'
        ) {
          res += ' (' + hit.variant_title + ')';
        }

        return res;
      };
      function canonicalHandle(hit) {
        var res = hit.handle;

        if (hit.meta && hit.meta.product && hit.meta.product.canonical) {
          res = hit.meta.product.canonical;
        }

        return res;
      };
      function canonicalLink(hit) {
        const addVariantId = hit.objectID !== hit.id;
        var handle = hit.handle;

        if (hit.meta && hit.meta.product && hit.meta.product.canonical) {
          handle = hit.meta.product.canonical;
        }

        return (
          '/products/' +
          handle +
          (addVariantId ? '?variant=' + hit.objectID : '')
        );
      };
      function getNamedTagValue(namedTags, key) {
        if (typeof namedTags === 'object' && namedTags !== null) {
          return namedTags[key] || []; // Return an empty array if the key is not found
        }
        return []; // Return an empty array if namedTags is not an object
      }
      function itemTemplate(hit) {
        const hitPriceData = priceData(hit);
        // On image: the same red badge as the product page, moved out of the badge row below
        const imageBadge = badgeOnImage ? renderRecommendationSavingsBadge(hit).replace('plp-sale-savings-badge', 'pdp-sale-savings-badge') : '';
        const savingsBadge = badgeOnImage ? '' : renderRecommendationSavingsBadge(hit);
        const canOrder = hit.inventory_available > 0 || hit.inventory_policy === 'continue' || hit.product_type === 'Gift Cards';
        const customSale = displayCustomSalesBadge(
          hit.meta?.product?.sale_badge_text,
          hit.meta?.product?.sale_start_date,
          hit.meta?.product?.sale_end_date
        );
        const primaryBadge = !canOrder
          ? `${savingsBadge}<span class="badge color-inverse">${algoliaShopify.translations.outOfStock}</span>`
          : algoliaShopify.b2b
            ? ''
            : customSale
              ? `${hit.compare_at_price > hit.price && hit.meta.product.display_both_sale_badges === true ? `<span class="badge color-${saleColor}">Sale</span>` : ''}<span class="badge color-custom-sale-badge">${hit.meta.product.sale_badge_text}</span>${savingsBadge}`
              : savingsBadge;
        const review = reviewData(hit);
        var isNewArrival = Array.isArray(hit.tags) && hit.tags.includes('New Arrival');
        var isLifetimeWarranty = Array.isArray(hit.tags) && hit.tags.includes('Lifetime Warranty');
        var isExclusive = Array.isArray(hit.tags) && hit.tags.includes('Exclusive');
        var isTeamsPick = Array.isArray(hit.tags) && hit.tags.includes('Teams Pick');
        var isBestSeller = Array.isArray(hit.tags) && hit.tags.includes('Best Seller');
        const customBadges = {
          1: null,
          2: null,
          3: null,
          4: null,
          5: null
        };

        if (typeof hit.named_tags === 'object' && hit.named_tags !== null) {
          for (let i = 1; i <= 5; i++) {
            const key = `Custom Badge ${i}`;
            const value = hit.named_tags[key];
            customBadges[i] = value && value.trim() !== "" ? value.trim() : null;
          }
        }


        return `
        <li class="ais-Hits-item-recommend">
          <div
            class="ais-hit ais-product"
            data-algolia-objectid="${hit.objectID}"
            data-handle="${canonicalHandle(hit)}"
            data-variant-id="${hit.objectID}"
            data-distinct="${hit._distinct}"
            data-product-id="${hit.id}"
            onclick="algoliaShopify.helpers.handleItemClick(${hit.objectID})"

          >
            ${imageBadge ? `<span class="cf__img-badge">${imageBadge}</span>` : ''}
            <div class="ais-hit--picture-wrapper" style="aspect-ratio: 1 / 1; width: 100%;">
              <a
                data-algolia-objectid="${hit.objectID}"
                href="${canonicalLink(hit)}"
              >
                <img
                  class="ais-hit--picture"
                  src="${algoliaShopify.helpers.mediumImage(hit)}"
                  alt="${plpTitle(hit)}"
                  style="height: 100% !important; width: 100% !important; object-fit: contain; object-position: center;"
                />
              </a>
            </div>
            <div class="ais-hit--details" >
              <a
                data-algolia-objectid="${hit.objectID}"
                href="${canonicalLink(hit)}"
              >
                <p class="ais-hit--title">${hit.vendor}</p>
                <p class="ais-hit--title-model">${plpTitleModel(hit)}</p>
                <p class="ais-hit--subtitle" title="${plpTitle(hit)}">${plpTitleColour(hit)}</p>

                <div class="ais-hit--price-container">
                  ${
                    hitPriceData.display_compare_at_price
                      ? `<p class="ais-hit--price-striked">${hitPriceData.display_compare_at_price_formatted}</p>
                        <p class="${hitPriceData.catalog_price ? 'ais-hit--b2b-price' : 'ais-hit--sale-price'}">${hitPriceData.display_price_formatted}</p>`
                      : `<p class="${hitPriceData.catalog_price ? 'ais-hit--b2b-price' : 'ais-hit--price'}">${hitPriceData.display_price_formatted}</p>`
                  }
                </div>

                ${
                  algoliaShopify.b2b && hitPriceData.display_compare_at_price
                    ? `<p class="ais-hit--margin"> Margin: ${hitPriceData.margin_formatted}</p>`
                    : ''
                }

                ${reviewRatingMarkup(review)}

                <p class="ais-hit--badge-container">
                  ${primaryBadge}
                  ${!primaryBadge ? `
                  ${isNewArrival ? `<span class="badge color-new-arrivals-badge">New</span>` : ''}
                  ${isExclusive ? `<span class="badge color-exclusive-badge">Exclusive</span>` : ''}
                  ${isTeamsPick ? `<span class="badge color-teams-pick-badge">Teams Pick</span>` : ''}
                  ${isBestSeller ? `<span class="badge color-best-seller-badge">Best Seller</span>` : ''}
                  ${customBadges[1] ? `<span class="badge color-custom-badge-1">${customBadges[1]}</span>` : ''}
                  ${customBadges[2] ? `<span class="badge color-custom-badge-2">${customBadges[2]}</span>` : ''}
                  ${customBadges[3] ? `<span class="badge color-custom-badge-3">${customBadges[3]}</span>` : ''}
                  ${customBadges[4] ? `<span class="badge color-custom-badge-4">${customBadges[4]}</span>` : ''}
                  ${customBadges[5] ? `<span class="badge color-custom-badge-5">${customBadges[5]}</span>` : ''}
                  ` : ''}
                </p>
              </a>
            </div>
          </div>
        </li>
        `;
      }


  return itemTemplate;
}

if (!customElements.get('mtbd-featured-collection')) {
  customElements.define('mtbd-featured-collection', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('.cf__scroll');
      this.prev = this.querySelector('.cf__nav--prev');
      this.next = this.querySelector('.cf__nav--next');
      this.dots = this.querySelector('.cf__dots');
      this.status = this.querySelector('.cf__status');
      this.loaded = false;
      this.loading = false;
      this.attempts = 0;
      this.prev.addEventListener('click', () => this.move(-1), { signal });
      this.next.addEventListener('click', () => this.move(1), { signal });
      this.track.addEventListener('scroll', () => this.updateControls(), { passive: true, signal });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, { signal });
      this.observer = new ResizeObserver(() => this.updateControls());
      this.observer.observe(this.track);
      document.addEventListener('algolia.autocomplete.beforeInit', () => this.loadProducts(), { signal });
      this.loadProducts();
    }

    disconnectedCallback() {
      this.controller.abort();
      this.observer.disconnect();
      clearTimeout(this.retry);
    }

    async loadProducts() {
      if (!this.isConnected || this.loading || this.loaded) return;
      if (!this.dataset.collection) {
        this.showStatus('empty');
        return;
      }
      const algolia = window.algoliaShopify;
      if (!algolia?.searchClient || typeof renderRecommendationSavingsBadge !== 'function') {
        clearTimeout(this.retry);
        if (++this.attempts <= 40) this.retry = setTimeout(() => this.loadProducts(), 250);
        else this.showStatus('error');
        return;
      }
      clearTimeout(this.retry);
      this.loading = true;
      const signal = this.controller.signal;
      try {
        let filters = 'collections:' + JSON.stringify(this.dataset.collection);
        if (window.catalog) filters += ' AND NOT "named_tags.Exclude Customer":' + JSON.stringify(window.catalog);
        const { results } = await algolia.searchClient.search({
          requests: [{
            indexName: algolia.config.index_prefix + 'products',
            query: '',
            filters,
            hitsPerPage: Number(this.dataset.limit)
          }]
        });
        if (signal.aborted) return;
        const hits = results[0]?.hits || [];
        if (!hits.length) {
          this.showStatus('empty');
          return;
        }
        const render = createFeaturedCollectionItemRenderer(this.dataset.saleColor, this.dataset.badgeOnImage === 'true');
        this.track.innerHTML = hits.map(render).join('');
        const viewAll = this.querySelector('template[data-view-all]');
        if (viewAll) this.track.appendChild(viewAll.content.cloneNode(true));
        this.track.setAttribute('aria-busy', 'false');
        this.loaded = true;
        this.status.hidden = true;
        if (this.dots) {
          this.dots.replaceChildren();
          Array.from(this.track.children).forEach((_, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'cf__dot';
            dot.setAttribute('aria-label', this.dataset.dotLabel.replace('[number]', index + 1));
            dot.addEventListener('click', () => {
              const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
              this.track.scrollTo({ left: max * index / Math.max(1, this.track.children.length - 1), behavior: this.motion() });
            }, { signal });
            this.dots.appendChild(dot);
          });
        }
        this.track.scrollLeft = 0;
        this.updateControls();
      } catch (error) {
        if (!signal.aborted) {
          this.showStatus('error');
          console.error('Algolia featured collection search failed:', error);
        }
      } finally {
        if (!signal.aborted) this.loading = false;
      }
    }

    showStatus(kind) {
      this.track.replaceChildren();
      this.track.setAttribute('aria-busy', 'false');
      this.status.textContent = this.status.dataset[kind];
      this.status.hidden = false;
      this.updateControls();
    }

    motion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    move(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: this.motion() });
    }

    updateControls() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const x = Math.max(0, this.track.scrollLeft);
      this.prev.hidden = !this.loaded || max <= 4 || x <= 4;
      this.next.hidden = !this.loaded || max <= 4 || x >= max - 4;
      if (!this.dots) return;
      this.dots.hidden = !this.loaded || max <= 4;
      const active = max > 4 ? Math.min(this.dots.children.length - 1, Math.round(x / max * (this.dots.children.length - 1))) : 0;
      Array.from(this.dots.children).forEach((dot, index) => {
        dot.classList.toggle('cf__dot--active', index === active);
        dot.setAttribute('aria-current', index === active ? 'true' : 'false');
      });
    }
  });
}
